import { useTranslation } from 'react-i18next';

import type { ButtonProps, ButtonVariant } from '@innovamat/glimmer-components';
import { Modal } from '@innovamat/glimmer-components';

type ConfirmationModalProps = {
  cancelText?: string;
  confirmText: string;
  isOpen: boolean;
  isPending?: boolean;
  message: string | JSX.Element;
  title: string;
  zIndex?: number;
  onClose?: () => void;
  onConfirm?: () => void;
};

export function ConfirmationModal({
  cancelText,
  confirmText,
  isOpen,
  isPending,
  message,
  title,
  zIndex,
  onClose,
  onConfirm,
}: ConfirmationModalProps): JSX.Element {
  const { t } = useTranslation();
  const buttons = [
    onConfirm && {
      children: confirmText,
      variant: 'accent' as ButtonVariant,
      loading: isPending,
      onClick: onConfirm,
    },
    onClose && {
      children: cancelText || t('common.cancel'),
      variant: 'tertiary' as ButtonVariant,
      onClick: onClose,
    },
  ].filter(Boolean);

  return (
    <Modal
      modalWidth={500}
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      buttons={(buttons as ButtonProps[]) ?? ([] as ButtonProps[])}
      zIndex={zIndex}
    >
      <>{message}</>
    </Modal>
  );
}
